import {Injectable} from "@angular/core";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {CustomerAccountTraderDataLoadingService} from "./customer-account-trader-data-loading.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountTraderTableConfigService  {

  constructor(private readonly dataLoadingService: CustomerAccountTraderDataLoadingService) {
  }

  public loadConfig(): TableColumnConfig[]{

    return [
      {
        field: 'owner',
        width: 130
      },
      {
        field: 'customerName',
        width: 130,
      },
      {
        field: 'exchangeCode',
        width: 150,
        icon: (record: AccountDefinition) => {
          if (this.dataLoadingService.exchangeCodes) {
            const exchField = this.dataLoadingService.exchangeCodes.find(exchange => exchange.value && exchange.value.code === record.exchangeCode);
            if (exchField && exchField.value)
              return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          }
          return 'fas fa-globe-europe';
        },
      },
      {
        field: 'accountCode',
        width: 130
      },
      {
        field: 'traderCode',
        width: 130
      },
      {
        field: 'contractList',
        width: 130
      },
    ];

  }

}
